<template>
  <section class="i-settings">
    <v-tabs dark slider-color="red">
      <v-tab
        v-for="tab in tabs"
        :key="`tab-${tab.route}`"
        ripple
        :to="{ name: tab.route }"
      >
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <v-card class="i-settings__content">
      <router-view />
    </v-card>
  </section>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'Speakers',
    data () {
      return {
        tabs: [
          {
            name: 'Form Settings',
            route: 'speakers-form'
          },
          {
            name: 'Speakers Table',
            route: 'speakers-table'
          },
          {
            name: 'Page Settings',
            route: 'speakers-page'
          },
          {
            name: 'Speakers Order',
            route: 'speakers-order'
          },
          {
            name: 'Speakers for Home page',
            route: 'speakers-home-page'
          }
        ]
      }
    },
    methods: {
      ...mapActions(['getFormByType'])
    },
    async created () {
      await this.getFormByType('speaker_registration')
    }
  }
</script>

<style lang="scss" scoped>
  .i-settings {
    &__content {
      padding: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Speakers/index.vue